<template>
  <div class="container">
    <!-- vant导航栏 -->
    <van-nav-bar style="background-color: #3090EC;">

      <template #left>
        <van-icon @click="back" color="white" size="24px" name="cross" />
      </template>

      <template #title>
        <span style="color: white;">欢迎登录</span>
      </template>

    </van-nav-bar>

    <van-form ref="loginForm" validate-first @submit="loginIn">
      <van-cell-group>
        <van-field v-model="phone" type="tel" maxlength="11" name="phone" :rules="phoneRules" placeholder="请输入手机号码" />
        <van-field v-model="verifycode" name="verifycode" :rules="[{ required: true, message: '请输入短信验证码' }]" center
          clearable placeholder="请输入短信验证码">
          <van-button slot="button" @click.stop="sendVerifycode()" :disabled="!disabledCodeBtn" size="small"
            type="primary">{{codeText}}</van-button>
        </van-field>

        <div class="remake">
          未注册的手机号码验证后自动创建账户
        </div>
      </van-cell-group>

      <div class="btn_box">
        <van-button native-type="submit" size="large" class="blue-btn">
          登 录
        </van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import { Form, Field, CellGroup, Checkbox, NavBar, Icon } from 'vant'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { sendMeaasge, loginByPhone } from '@/api/user'
import { mapGetters } from 'vuex'
export default {
  name: 'Login',
  components: {
    [Form.name]: Form,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [Checkbox.name]: Checkbox,
    [NavBar.name]: NavBar,
    [Icon.name]: Icon,
  },
  computed: {
    ...mapGetters(['token'])
  },
  mounted () {
    this.phone = null
    this.verifycode = null
    this.isAgree = false
    this.$refs.loginForm.resetValidation()
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect
      },
      immediate: true
    }
  },
  data () {
    this.phoneRules = [
      { required: true, message: '请输入手机号码' },
      { validator: this.phoneValidator, message: '手机号码格式错误' },
    ];
    return {
      phone: null,
      verifycode: null,
      disabledCodeBtn: true,
      codeText: '获取',
      redirect: undefined,
      isAgree: false
    }
  },
  methods: {
    //发送验证码
    sendVerifycode () {
      let _this = this
      _this.$refs.loginForm.resetValidation()
      if (getToken('verify_condition')) {
        _this.$notify({
          type: 'danger',
          message: "获取验证码频繁"
        })
        return
      }
      _this.$refs.loginForm.validate('phone').then(() => {
        let params = {
          phone: _this.phone
        }
        _this.countDown(60)
        sendMeaasge(params).then(response => {
          if (response.status === 1001) {
            setToken('verify_condition', 1, 60)
          } else {
            _this.$notify({
              type: 'danger',
              message: response.message || "获取验证码失败"
            })
          }
        }).catch(error => {
          _this.$notify({
            type: 'danger',
            message: error.message || "获取验证码失败"
          })
        })
      }).catch(() => {
        return
      })
    },
    // 验证登录
    loginIn () {
      let _this = this
      _this.$refs.loginForm.validate().then(() => {
        let params = {
          phone: _this.phone,
          code: _this.verifycode
        }
        loginByPhone(params).then(async res => {
          if (res.status === 1001) {
            //验证码正确
            let data = res.body;
            if (_this.token) {
              // 已第三方登录
              await _this.$store.dispatch('BindUserAndPid', { phone: _this.phone })
              await _this.$store.dispatch('Login', {})
            } else {
              // 未第三方登录
              if (Object.keys(data).length === 0) {
                // 该手机号码未注册，则先注册
                await _this.$store.dispatch('Register', { phone: _this.phone })
              }
              await _this.$store.dispatch('Login', { phone: _this.phone })
            }
            _this.$router.push({ path: _this.redirect || '/' })
          } else {
            //验证码无效
            _this.$notify({
              type: 'danger',
              message: res.message || "登陆失败 请尝试重新登录"
            })
            _this.$store.dispatch('FedLogOut');//登陆失败，清空数据，防止再次点击进入页面
          }
        }).catch(err => {
          _this.$notify({
            type: 'danger',
            message: err.message || "登陆失败请尝试重新登录"
          })
          _this.$store.dispatch('FedLogOut');//登陆失败，清空数据，防止再次点击进入页面
        })
      }).catch(error => {
        _this.$notify({
          type: 'danger',
          message: error[0].message || "请验证输入内容"
        })
      })
    },
    back () {
      if (this.$route.query.noGoBack) {
        this.$router.push({ path: '/' })
      } else {
        this.$router.go(-1)
      }
    },
    // 倒计时方法
    countDown (time) {
      if (time === 0) {
        this.disabledCodeBtn = true
        this.codeText = "获取"
        removeToken('verify_condition')
        return
      } else {
        this.disabledCodeBtn = false;
        this.codeText = `重新发送${time}`
        time--
      }
      setTimeout(() => {
        this.countDown(time)
      }, 1000)
    },
    phoneValidator (val) {
      return /^1[3|4|5|6|7|8|9][0-9]\d{8}$/.test(val);
    },
    // 绑定手机号码以及用户编号
    bindByUserIdAndPhone () {

    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  /deep/ .van-form {
    padding: 24px 0 24px;
  }
  .remake {
    color: rgb(187, 187, 187);
    font-size: 12px;
    text-align: center;
  }
  .strategy {
    color: skyblue;
    font-size: 14px;
    cursor: pointer;
    display: flex;
    justify-content: center;
  }
  .btn_box {
    margin-top: 10px;
    padding: 0 15px;
  }
}
</style>